const alphaSerie = /^[0-9A-ZÁÉÍÑÓÚÜÄÖÜßČĎĚŇŘŠŤŮÝŽ/\-.\s][0-9A-ZÁÉÍÑÓÚÜÄÖÜßČĎĚŇŘŠŤŮÝŽ/\-_.\s]*$/i
export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return alphaSerie.test(value)
  }
}
